/**
 * Models a navigation tab. Use with a tab collection and the generic tab template
 */

import Brace from "backbone.brace";

const Model = Brace.Model.extend({
  namedAttributes: {
    id: String,
    label: String,
    active: Boolean,
    view: Function,
    viewModel: Function,
    data: Object,
  },
  defaults: {
    id: null,
    label: null,
    active: null,
    view: null,
    viewModel: null,
    data: {},
  },
});

export { Model as default };
